import { EventsEnum } from '../engine/models/events.enum';

declare const Human;

export interface RPCEvent<RPCResponse> {
  eventName: EventsEnum;
  aliasEvents?: EventsEnum[];
  mapFn?: (params: any) => RPCResponse;
}

export function defineEvent<RPCResponse>(
  eventName: EventsEnum,
  aliasEvents?: EventsEnum[],
  mapFn?: (params: any) => RPCResponse
) {
  Human.rpc.defineEvent(eventName, {
    events: aliasEvents || [eventName],
    map: mapFn ? mapFn : (params: any) => <RPCResponse>params
  });
}
